import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../../../../../utilities/formatDate";
import localeText from "../../../../../../locale";

const EconomicCircleRecentMembersCard = ({ members = [] }) => (
  <div
    className="card border-round-md p-3"
    style={{ border: "1px solid var(--theme-border, #EBEBEB)" }}
  >
    <div className="flex align-items-center justify-content-between mb-3">
      <span
        className="text-sm font-semibold"
        style={{ color: "var(--theme-text)" }}
      >
        {localeText("recentMembers") || "Membros recentes"}
      </span>
      <Link
        to="/dashboard-economic-circle/members?tab=members"
        className="text-sm font-medium"
        style={{ color: "var(--theme-primary)" }}
      >
        {localeText("viewAll") || "Ver todos"}
      </Link>
    </div>
    <div className="border-top-1 pt-2 mt-2" style={{ borderColor: "var(--theme-border)" }}></div>
    <ul className="list-none p-0 m-0">
      {members.length === 0 ? (
        <li className="py-2 text-sm" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("noRecentMembers") || "Nenhum membro recente."}
        </li>
      ) : (
        members.map((m, i) => (
          <li
            key={i}
            className="flex align-items-center gap-2 py-2"
          >
            <div
              className="border-circle w-2rem h-2rem flex align-items-center justify-content-center text-xs font-medium"
              style={{
                backgroundColor: "var(--theme-border)",
                color: "var(--theme-text)",
              }}
            >
              {(m.node || m.nodeusername || "?").slice(0, 2).toUpperCase()}
            </div>
            <div className="flex-1">
              <span className="text-sm font-medium" style={{ color: "var(--theme-text)" }}>
                {m.node || m.nodeusername}
              </span>
              <span className="text-xs ml-2" style={{ color: "var(--theme-text-muted)" }}>
                {m.plan}
              </span>
            </div>
            <span className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {m.date ? formatDate(new Date(m.date)) : "-"}
            </span>
          </li>
        ))
      )}
    </ul>
  </div>
);

export default EconomicCircleRecentMembersCard;
